import {distinctUntilChanged, Subject} from 'rxjs';
import {SocketService, SocketState} from './SocketService';
import {io} from 'socket.io-client';
import {environment} from '~local/environments/environment';
import {map} from 'rxjs/operators';
import {inject} from '@angular/core';

export abstract class SocketNamespaceServiceBase {
    protected readonly socketService = inject(SocketService);

    protected eventSubject: Subject<{ name: string, args?: any[] }> = new Subject<{ name: string, args?: any[] }>();
    protected socket;

    protected constructor(
        protected readonly namespace: string,
    ) {
        this.socket = io(environment.socketHost + this.namespace, {transports: ['websocket'], autoConnect: false});

        this.onConnect = this.onConnect.bind(this);
        this.onDisconnect = this.onDisconnect.bind(this);
        this.onSocketError = this.onSocketError.bind(this);

        this.socket.on('connect', this.onConnect);
        this.socket.on('disconnect', this.onDisconnect);
        this.socket.on('error', this.onSocketError);

        this.socketService.state$.pipe(
            map($ => $ === SocketState.CONNECTED),
            distinctUntilChanged(),
        ).subscribe($parentConnected => {
            if ($parentConnected) {
                this.socket.connect();
            } else {
                this.socket.disconnect();
            }
        });

        this.initListeners();
    }

    protected onConnect(): void {
    }

    protected onDisconnect(): void {
    }

    protected onSocketError(): void {
    }

    protected abstract initListeners(): void;
}
